import React from 'react';
import { Button, Form, Modal, Select } from 'antd';
import { countries } from 'countries-list';
import { func } from 'helpers';

const Globe = ({ visible, onCancel }) => {

    const [form] = Form.useForm();

    return (
        <React.Fragment>
            <Modal open={visible} title="Change location" width={450} centered footer={null} maskClosable={false} destroyOnClose={true} onCancel={onCancel}>
                <Form form={form} layout="vertical">
                    <Form.Item name="country" label="Country" initialValue={func.getCookie('country')}>
                        <Select size="large" showSearch optionFilterProp="children" onChange={e => {
                            func.setCookie('country', e, 1);
                        }}>
                            {Object.keys(countries).map(country => (
                                <Select.Option key={country} value={country}>{countries[country].name}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item name="lang" label="Language" initialValue={func.getCookie('lang')}>
                        <Select size="large" showSearch optionFilterProp="children" onChange={e => {
                            func.setCookie('lang', e, 1);
                        }}>
                            {['EN', 'FR'].map(lang => (
                                <Select.Option key={lang} value={lang}>{lang}</Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <p>&nbsp;</p>
                    <Button size="large" type="primary" block onClick={() => window.location.reload()}>
                        Refresh
                    </Button>
                </Form>
            </Modal>
        </React.Fragment>
    );
}

export default Globe;